import { formatPrice } from 'utils/helpers/functions/formatPrice';
import { getBaseCurrencyPrefix, withLocalCurrency } from 'utils/helpers/currency/currencyHelpers';
import SolarIcon from 'components/icons/SolarIcon';
import { rateTitle } from '../model';

interface DashHeroProps {
    isUahMode: boolean;
    profitability: number;
    profitabilityRate?: number;
    profitabilityLabel: string;
    price: number;
}

const DashHero = ({
    isUahMode,
    profitability,
    profitabilityRate,
    profitabilityLabel,
    price,
}: DashHeroProps) => {
    const marginPct = price > 0 ? Math.round((profitability / price) * 100) : null;
    const profitClass = profitability < 0 ? 'text-danger' : 'text-success';

    return (
        <div className="object-analytics-dash__hero">
            <div className="object-analytics-dash__hero-copy">
                <span className="object-analytics-dash__kicker text-muted">
                    <SolarIcon name="graph-up-arrow" aria-hidden="true" />
                    {profitabilityLabel}
                </span>
                <div
                    className={`object-analytics-dash__hero-value ${profitClass}`}
                    title={rateTitle(isUahMode, profitabilityRate)}
                >
                    {isUahMode ? (
                        withLocalCurrency(formatPrice(profitability))
                    ) : (
                        <>
                            <small className={profitClass}>{getBaseCurrencyPrefix()}</small>
                            {formatPrice(profitability)}
                        </>
                    )}
                </div>
            </div>
            {marginPct != null ? (
                <div
                    className={`object-analytics-dash__pct ${profitability < 0 ? 'is-loss text-danger' : 'is-profit text-success'}`}
                    title={profitabilityLabel}
                >
                    {marginPct > 0 ? '+' : ''}
                    {marginPct}%
                </div>
            ) : null}
        </div>
    );
};

export default DashHero;
